import { render, staticRenderFns } from "./PopularTours.vue?vue&type=template&id=1664abdd&"
import script from "./PopularTours.vue?vue&type=script&lang=js&"
export * from "./PopularTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports